import React, { useState } from 'react';
import { Modal, Button, Upload, message, Row, Col, Typography } from 'antd';
import { DownloadOutlined, InboxOutlined, DeleteFilled } from '@ant-design/icons';
import { downloadBlobFile, uploadBlobFile } from '@utils/utils';
import { URL_API } from '@configs/index';
import { showError } from '@components/notification';

const { Text } = Typography;

const ModalImportManualReadings = ({ visible, onCancel, selectedMonth }) => {
  const [file, setFile] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [loadingImport, setLoadingImport] = useState(false);

  const handleDownloadTemplate = async () => {
    try {
      setLoadingTemplate(true);
      await downloadBlobFile(
        `${URL_API}/api/statistics-month/export-template-manual-readings`,
        'File mẫu import chỉ số đọc thủ công.xlsx',
        { period: selectedMonth },
        'GET'
      );
    } catch (e) {
      showError('Có lỗi xảy ra, vui lòng liên hệ ban quản trị');
    } finally {
      setLoadingTemplate(false);
    }
  };

  const beforeUpload = (file) => {
    setFile(file);
    return false;
  };

  const handleSubmit = async () => {
    try {
      setLoadingImport(true);
      if (!file) {
        message.warning('Bạn phải chọn file trước khi nhập!');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      await uploadBlobFile(
        `${URL_API}/api/statistics-month/import-manual-readings`,
        'Kết quả import.xlsx',
        formData
      );
      message.success('Import dữ liệu thành công!');
      setFile(null);
      onCancel();
    } catch (e) {
      showError('Có lỗi xảy ra, vui lòng liên hệ ban quản trị');
    } finally {
      setLoadingImport(false);
    }
  };

  const handleRemove = () => {
    setFile(null);
  };

  return (
    <Modal
      title="Nhập dữ liệu chỉ số đọc thủ công từ file excel"
      open={visible}
      loading={loadingImport}
      onCancel={() => {
        setFile(null);
        onCancel();
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            setFile(null);
            onCancel();
          }}
          style={{
            height: '36px'
          }}>
          Hủy bỏ
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={loadingImport}
          style={{
            color: '#fff',
            height: '36px',
            backgroundColor: '#0051A9',
            borderColor: '#0051A9'
          }}>
          Nhập dữ liệu
        </Button>
      ]}>
      <Row gutter={[16, 16]} style={{ marginTop: '0px' }}>
        <Col span={24}>
          <Button
            loading={loadingTemplate}
            type="link"
            icon={<DownloadOutlined />}
            onClick={handleDownloadTemplate}
            block
            style={{
              color: '#0051A9',
              fontSize: '16px'
            }}>
            Tải về file mẫu
          </Button>
          <Text
            type="secondary"
            style={{ fontSize: '13px', display: 'block', textAlign: 'center' }}>
            (Lưu ý khi import thành công để áp dụng dữ liệu mới cần tính toán lại tiêu thụ)
          </Text>
        </Col>
        <Col span={24}>
          {!file ? (
            <Upload.Dragger beforeUpload={beforeUpload} showUploadList={false}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Nhấn hoặc thả file vào để tải lên</p>
              <p className="ant-upload-hint">Vui lòng chỉ tải file excel dạng .xlsx</p>
            </Upload.Dragger>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px 0'
              }}>
              <Text strong>{file.name}</Text>
              <Button
                type="link"
                icon={<DeleteFilled style={{ color: '#0051A9', fontSize: '18px' }} />}
                onClick={handleRemove}></Button>
            </div>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalImportManualReadings;
